export default "__VITE_ASSET__645018c8__"